import { Stack, Typography } from '@mui/material';

import CircularWarningIcon from '../../assets/icons/CircularWarning';

interface CardAlertProps {
  value: 'Expired' | 'Cancelled';
}

const CardAlert = ({ value }: CardAlertProps) => {
  return (
    <Stack direction="row" sx={{
      alignItems: "center"
    }}>
      <CircularWarningIcon
        sx={{
          marginRight: 1,
        }}
      />
      <Typography
        sx={{
          fontFamily: 'Cabin',
          fontKerning: 'normal',
          fontSize: '14px',
          fontWeight: 700,
        }}
      >
        {value}
      </Typography>
    </Stack>
  );
};

export default CardAlert;
